import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useOutletContext } from "react-router-dom";
import CompensationAdd from "../Candidate/CompensationAdd";
import NewInterviewer from "./NewInterviewer";
import toastr from "../../../utils/toast";
import ContributionForm from "./ContributionForm";
import Select from "react-select";
import { Controller } from "react-hook-form";

function EditStatus({ candidate_id, role_id, minor_status, onClose }) {
  const {
    register,
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors, dirtyFields },
  } = useForm();

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const REACT_APP_BASE_URL_BACK = process.env.REACT_APP_BASE_URL_BACK;
  const { setGlobalLoading, token } = useOutletContext();
  const [data, setData] = useState([]);
  const [newInterviewerModel, setNewInterviewerModel] = useState(false);
  const [compModel, setCompModel] = useState(false);
  const [HasComp, setHasComp] = useState(false);
  const [meetingPlace, setMeetingPlace] = useState(false);
  const [backgroundCheck, setBackgroundCheck] = useState(false);
  const [showResume, setShowResume] = useState(false);
  const [timediv, setTimediv] = useState(false);
  const [showDossier, setShowDossier] = useState(false);
  const [Evaluation, setEvaluation] = useState(false);
  const [MeetingWith, setMeetingWith] = useState(false);
  const [CompReq, setCompReq] = useState(false);
  const [viewComp, setViewComp] = useState(false);
  const [CandidateClosed, setCandidateClosed] = useState(false);
  const [ReqDossier, setReqDossier] = useState(false);
  const [LogData, setLogData] = useState([]);
  const mnstatus = useRef(null);
  const [Contribution, setContribution] = useState(false);
  const [showContributionForm, setShowContributionForm] = useState(false);
  const [candidateData, setCandidateData] = useState({});
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const selectedResume = watch("userfile");
  const selectedDossier = watch("userfile1");
  const selectedBackground = watch("userfile2");

  const hasNewResume = selectedResume?.length > 0;
  const hasNewDossier = selectedDossier?.length > 0;
  const hasNewBackground = selectedBackground?.length > 0;

  const [pendingFormData, setPendingFormData] = useState(null);

  const Get_Comp = async () => {
    try {
      const respone = await axios.get(
        `${API_BASE_URL}/candidates/current_compensation/${candidate_id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      console.log(respone.data);
      if (respone.data.compensation[0]?.comp_id != null) setHasComp(true);
    } catch (error) {
      console.log(error);
    }
  };

  const role_details = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/roles/fetch_role_data/${role_id}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );
      if (response.data.role_data[0].dossier == 1) setReqDossier(true);
    } catch (error) {
      console.log(error);
    }
  };

  const get_basic_data = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/workstation/get_basic_data_edit_status_form/${role_id}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );
      setData(response.data);
      console.log(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetch_filter_log = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/workstation/fetch_filter_log/${candidate_id}/${role_id}/${minor_status}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );
      setLogData(response.data);
      console.log(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetch_email = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/candidates/fetch_email/${candidate_id}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );
      console.log(response?.data);
      setCandidateData(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const loadData = async () => {
    try {
      setGlobalLoading(true);
      await Promise.all([
        fetch_filter_log(),
        get_basic_data(),
        Get_Comp(),
        role_details(),
        fetch_email(),
      ]);
    } catch (err) {
      console.log(err);
    } finally {
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const interviewerOptions =
    data?.interview?.map((item) => ({
      value: item.id,
      label: `${item.firstname} ${item.lastname}`,
    })) || [];

  const memberOptions =
    data?.users?.map((item) => ({
      value: item.id,
      label: `${item.firstname} ${item.lastname}`,
    })) || [];

  useEffect(() => {
    if (!LogData?.filter_log?.length) return;

    const acLogData = LogData?.filter_log?.[0];
    const candidate_filters = LogData?.candidate_filters?.[0];
    const candidate_interviews = LogData?.candidate_interviews;

    if (
      LogData?.contribution !== null &&
      LogData?.contribution !== undefined &&
      LogData?.contribution == 1
    ) {
      setContribution(true);
    }

    // Normal inputs
    if (!dirtyFields.date) {
      setValue("date", acLogData?.date || "");
    }

    if (!dirtyFields.time) {
      setValue("time", acLogData?.time || "");
    }

    if (CandidateClosed !== false && !dirtyFields.candidate_type) {
      setValue("candidate_type", candidate_filters?.candidate_type || "");
    }

    if (!dirtyFields.comments) {
      setValue("comments", acLogData?.comments || "");
    }

    // Timezone dropdown
    const tzMatch = data?.timezones?.find(
      (tz) => parseInt(tz.id) === parseInt(acLogData?.timezone_id),
    );

    if (tzMatch && !dirtyFields.timezone_id) {
      setValue("timezone_id", tzMatch.id);
    }

    // Single select (action_by_id)
    const userMatch = data?.users?.find(
      (user) => user.id === acLogData?.action_by_id,
    );

    if (userMatch && !dirtyFields.action_by_id) {
      setValue("action_by_id", userMatch.id);
    }

    if (!dirtyFields.clientName) {
      const candidateInterviewId = candidate_interviews?.[0]?.interviewpanel_id;
      setValue("clientName", Number(candidateInterviewId) || []);
    }

    if (!dirtyFields.clientPlace) {
      setValue("clientPlace", candidate_interviews?.[0]?.clientPlace || "");
    }
    console.log("LogData", LogData);
  }, [LogData]);

  useEffect(() => {
    if (LogData && data) {
      const acLogData = LogData?.filter_log?.[0];
      const action_by_id_others =
        (acLogData?.action_by_id_others !== null &&
          acLogData?.action_by_id_others
            ?.split(",")
            .map((id) => parseInt(id))) ||
        [];

      const candidate_interviews =
        LogData?.candidate_interviews?.[0]?.interviewpanel_id?.split(",") || [];
      const interviewpanelIds = candidate_interviews.map((i) => parseInt(i));

      setValue("clientName", interviewpanelIds || []);
      setValue("action_by_id_others", action_by_id_others);
    }
  }, [LogData, data]);

  useEffect(() => {
    if (mnstatus.current) return;

    mnstatus.current = true;

    if ([19, 28, 29, 30, 43, 45, 54].includes(minor_status)) {
      setTimediv(true);
    }

    if (minor_status == 45) {
      setMeetingPlace(true);
    }

    if (minor_status == 48) {
      setBackgroundCheck(true);
    }

    if (minor_status == 54) {
      setCandidateClosed(true);
    }

    if (
      [
        27, 28, 29, 30, 31, 32, 33, 42, 43, 44, 45, 46, 47, 48, 49, 50, 54,
      ].includes(minor_status)
    ) {
      setShowResume(true);
    }

    if ([33, 42, 43, 44, 45, 46, 47, 48, 49, 50, 54].includes(minor_status)) {
      setShowDossier(true);
    }

    if ([28, 29, 30].includes(minor_status)) {
      setEvaluation(true);
    }

    if ([43, 45].includes(minor_status)) {
      setMeetingWith(true);
    }

    if (minor_status == 33 || (minor_status >= 42 && minor_status <= 54)) {
      setCompReq(true);
    }

    if (minor_status >= 20 && minor_status <= 54) {
      setViewComp(true);
    }
    console.log(minor_status);
  }, [minor_status]);

  async function check_role_contibution(role_id) {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/roles/fetch_role_contirbution_data/${role_id}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const result = response.data;

      return result;
    } catch (error) {
      console.log(error);
    }
  }

  const submitStatus = async (formDataValues) => {
    const payload = {
      ...formDataValues,
      candidate_id,
      role_id,
      status_id: minor_status,
    };

    const formData = new FormData();

    Object.keys(payload).forEach((key) => {
      if (key !== "userfile" && key !== "userfile1" && key !== "userfile2") {
        formData.append(key, payload[key]);
      }
    });

    if (payload.userfile instanceof FileList) {
      formData.append("userfile", payload.userfile[0]);
    }

    if (payload.userfile1 instanceof FileList) {
      formData.append("userfile1", payload.userfile1[0]);
    }

    if (payload.userfile2 instanceof FileList) {
      formData.append("userfile2", payload.userfile2[0]);
    }

    return axios.post(
      `${API_BASE_URL}/workstation/inline_edit_status`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      },
    );
  };

  const onSubmit = async (data) => {
    if (!HasComp && CompReq) {
      alert("Candidate Current Comp is Required");
      return;
    }

    const Contribution_rows = await check_role_contibution(role_id);

    if (Contribution_rows.length <= 0) {
      if (CandidateClosed && Contribution && user.designation_id <= 4) {
        setPendingFormData(data);
        setShowContributionForm(true);
        return;
      }
    }

    data = {
      ...data,
      candidate_id: candidate_id,
      role_id: role_id,
      status_id: minor_status,
    };
    setGlobalLoading(true);
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (key !== "userfile" && key !== "userfile1" && key !== "userfile2") {
        formData.append(key, data[key]);
      }
    });

    // ✅ Append files (from file inputs)
    if (data.userfile instanceof FileList) {
      formData.append("userfile", data.userfile[0]);
    }
    if (data.userfile1 instanceof FileList) {
      formData.append("userfile1", data.userfile1[0]);
    }
    if (data.userfile2 instanceof FileList) {
      formData.append("userfile2", data.userfile2[0]);
    }

    await axios
      .post(`${API_BASE_URL}/workstation/inline_edit_status`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          console.log(res);
          res.data?.missing_details != "" &&
            toastr.error(res.data?.missing_details);
          toastr.success(res.data.message);
          onClose(1);
        }
      })
      .catch((err) => {
        toastr.error(
          err?.response?.data?.error ||
            "Something went wrong. Please try again.",
        );
      })
      .finally(() => {
        setGlobalLoading(false);
      });
  };

  const emailCorrect = async (status) => {
    console.log(status);

    let email_verify = "";
    if (status === true) {
      email_verify = "1";
    } else {
      email_verify = "0";
    }

    const res = await axios.post(
      `${API_BASE_URL}/candidates/update_candidate_email_verify/`,
      {
        email_verify: email_verify,
        candidate_id: candidate_id,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    if (res.status === 200) {
      toastr.success(res.data.message);
      await fetch_email();
    }
  };

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            {compModel && (
              <CompensationAdd
                candidate_id={candidate_id}
                onClose={(status) => {
                  if (status == 1) {
                    setHasComp(true);
                  }
                  setCompModel(false);
                  loadData();
                }}
              />
            )}
            {newInterviewerModel && (
              <NewInterviewer
                role_id={role_id}
                onClose={(status) => {
                  if (status === 1) {
                    get_basic_data();
                  }
                  setNewInterviewerModel(false);
                  loadData();
                }}
              />
            )}

            {showContributionForm &&
              user.designation_id <= 4 &&
              Contribution && (
                <ContributionForm
                  role_id={role_id}
                  candidate_id={candidate_id}
                  onClose={async (status) => {
                    if (status === 1) {
                      toastr.success("Contribution Added Successfully");

                      setShowContributionForm(false);

                      if (pendingFormData) {
                        await submitStatus(pendingFormData);
                      }
                    } else {
                      setShowContributionForm(false);
                    }
                  }}
                />
              )}
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="modal-header">
                <h4 className="modal-title">
                  Further Required Details
                  {(CompReq || viewComp) && (
                    <i
                      onClick={() => {
                        setGlobalLoading(true);
                        setCompModel(true);
                      }}
                      title={`${HasComp ? "Update" : "Add"} Compensation`}
                      style={
                        HasComp
                          ? { cursor: "pointer" }
                          : {
                              animation: "blink 3s infinite",
                              cursor: "pointer",
                            }
                      }
                      className="fa-solid fa-circle-exclamation ms-1 badge bg-info"
                    >
                      <span className="fs-10">
                        {HasComp ? " Update" : " Add"} Compensation
                      </span>
                    </i>
                  )}
                </h4>
                <button
                  type="button"
                  onClick={onClose}
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x"></i>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-xxl-6 col-lg-12 col-md-6">
                    <div className="card">
                      <div className="card-body my-card-body">
                        {console.log(candidateData)}
                        {Object.keys(candidateData).length > 0 &&
                          candidateData.gdpr != null &&
                          candidateData.gdpr != "0" && (
                            <>
                              {candidateData.email_verify === "0" &&
                              candidateData.email != "" &&
                              candidateData.email != null ? (
                                <div className="row">
                                  <div className="col-md-12">
                                    <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                                      <div className="d-flex align-items-center justify-content-center avatar avatar-sm border border-dashed me-2 text-dark">
                                        <i className="fa-solid fa-envelope"></i>
                                      </div>
                                      <div className="d-flex align-items-center justify-content-md-between flex-grow-1">
                                        <h5 className="mb-1">
                                          {candidateData.email}{" "}
                                          <i
                                            style={{ cursor: "pointer" }}
                                            className="fa-solid fa-circle-info ms-1 text-info"
                                            title="Please verify the email address so we can share the GDPR consent form."
                                          ></i>
                                        </h5>
                                        <div>
                                          <button
                                            onClick={(e) => {
                                              e.preventDefault();
                                              if (
                                                window.confirm(
                                                  "Are you sure you want to mark this email as correct?",
                                                )
                                              ) {
                                                emailCorrect(true);
                                              }
                                            }}
                                            className="btn btn-sm btn-success "
                                          >
                                            Correct
                                          </button>
                                          <button
                                            onClick={(e) => {
                                              e.preventDefault();
                                              if (
                                                window.confirm(
                                                  "Are you sure you want to mark this email as incorrect?",
                                                )
                                              ) {
                                                emailCorrect(false);
                                              }
                                            }}
                                            className="btn btn-sm btn-danger ms-2"
                                          >
                                            Wrong
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <p className="text-danger">
                                  Please note - Email address is required so we
                                  can share the GDPR consent form.
                                </p>
                              )}
                            </>
                          )}
                        <div className="row">
                          {showResume && (
                            <div
                              className={`${
                                backgroundCheck ? "col-md-4" : "col-md-6"
                              }`}
                            >
                              <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                                <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 text-dark">
                                  <i
                                    onClick={() => {
                                      if (hasNewResume) {
                                        const fileURL = URL.createObjectURL(
                                          selectedResume[0],
                                        );
                                        window.open(fileURL, "_blank");
                                      }
                                    }}
                                    title={
                                      hasNewResume
                                        ? "View selected resume"
                                        : "No file selected"
                                    }
                                    className={`ti ti-file ${
                                      hasNewResume
                                        ? "text-success cursor-pointer"
                                        : "text-gray-2"
                                    }`}
                                    style={{ fontSize: "80px" }}
                                  ></i>
                                </div>
                                <div className="profile-upload">
                                  <div className="mb-2">
                                    <h6 className="mb-1">
                                      Upload Resume{" "}
                                      <span className="text-danger">
                                        {LogData?.resume?.length <= 0 && (
                                          <>* {errors.userfile?.message}</>
                                        )}
                                      </span>
                                    </h6>
                                    <p className="fs-12">
                                      File should be below 4 mb.
                                    </p>
                                  </div>
                                  <div className="profile-uploader d-flex align-items-center">
                                    <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                                      Upload
                                      <input
                                        {...register("userfile", {
                                          required:
                                            LogData?.resume?.length <= 0 &&
                                            "required",
                                        })}
                                        type="file"
                                        className="form-control image-sign"
                                      />
                                    </div>
                                    {LogData?.resume?.length > 0 && (
                                      <a
                                        target="_blank"
                                        href={`${REACT_APP_BASE_URL_BACK}candidate_files/${LogData?.resume[0].savename}`}
                                        className="btn btn-light btn-sm"
                                      >
                                        <i className="fa fa-file-pdf"></i>
                                        View Resume
                                      </a>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {showDossier && (
                            <div
                              className={`${
                                backgroundCheck ? "col-md-4" : "col-md-6"
                              }`}
                            >
                              <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                                <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 text-dark">
                                  <i
                                    onClick={() => {
                                      if (hasNewDossier) {
                                        const fileURL = URL.createObjectURL(
                                          selectedDossier[0],
                                        );
                                        window.open(fileURL, "_blank");
                                      }
                                    }}
                                    title={`${
                                      hasNewDossier
                                        ? "View Dossier"
                                        : "No file selected"
                                    }`}
                                    className={`ti ti-file ${
                                      hasNewDossier
                                        ? "text-success cursor-pointer"
                                        : "text-gray-2"
                                    } `}
                                    style={{ fontSize: "80px" }}
                                  ></i>
                                </div>
                                <div className="profile-upload">
                                  <div className="mb-2">
                                    <h6 className="mb-1">
                                      Upload Dossier{" "}
                                      {ReqDossier && (
                                        <span className="text-danger">
                                          {LogData?.dossier?.length <= 0 && (
                                            <>* {errors.userfile1?.message}</>
                                          )}
                                        </span>
                                      )}
                                    </h6>
                                    <p className="fs-12">
                                      File should be below 4 mb
                                    </p>
                                  </div>
                                  <div className="profile-uploader d-flex align-items-center">
                                    <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                                      Upload
                                      <input
                                        type="file"
                                        className="form-control image-sign"
                                        {...register("userfile1", {
                                          required:
                                            ReqDossier &&
                                            LogData?.dossier?.length <= 0
                                              ? "required"
                                              : "",
                                        })}
                                      />
                                    </div>
                                    {LogData?.dossier?.length > 0 && (
                                      <a
                                        target="_blank"
                                        href={`${REACT_APP_BASE_URL_BACK}candidate_files/${LogData?.dossier[0].savename}`}
                                        className="btn btn-light btn-sm"
                                      >
                                        <i className="fa fa-file-pdf"></i>
                                        View Dossier
                                      </a>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {backgroundCheck && (
                            <div className="col-md-4">
                              <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                                <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 text-dark">
                                  <i
                                    onClick={() => {
                                      if (hasNewBackground) {
                                        const fileURL = URL.createObjectURL(
                                          selectedBackground[0],
                                        );
                                        window.open(fileURL, "_blank");
                                      }
                                    }}
                                    style={{ fontSize: "80px" }}
                                    title={`${
                                      hasNewBackground
                                        ? "View Background"
                                        : "No file selected"
                                    }`}
                                    className={`ti ti-file ${
                                      hasNewBackground
                                        ? "text-success cursor-pointer"
                                        : "text-gray-2"
                                    }`}
                                  ></i>
                                </div>
                                <div className="profile-upload">
                                  <div className="mb-2">
                                    <h6 className="mb-1">
                                      Upload Background File
                                      <span className="text-danger">
                                        {LogData?.background?.length <= 0 && (
                                          <>* {errors.userfile2?.message}</>
                                        )}
                                      </span>
                                    </h6>
                                    <p className="fs-12">
                                      File should be below 4 mb
                                    </p>
                                  </div>
                                  <div className="profile-uploader d-flex align-items-center">
                                    <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                                      Upload
                                      <input
                                        type="file"
                                        className="form-control image-sign"
                                        {...register("userfile2", {
                                          required:
                                            LogData?.background?.length <= 0 &&
                                            "required",
                                        })}
                                      />
                                    </div>
                                    {LogData?.background?.length > 0 && (
                                      <a
                                        target="_blank"
                                        href={`${REACT_APP_BASE_URL_BACK}candidate_files/${LogData?.background[0].savename}`}
                                        className="btn btn-light btn-sm"
                                      >
                                        <i className="fa fa-file-pdf"></i>
                                        View File
                                      </a>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        {timediv && (
                          <div className="row">
                            <div className="col-xxl-4 col-lg-4 col-md-4">
                              <div className="mb-3">
                                <label className="form-label">
                                  {CandidateClosed ? "Date of Joining" : "Date"}{" "}
                                  <span className="text-danger">
                                    * {errors?.date?.message}
                                  </span>
                                </label>
                                <input
                                  type="date"
                                  {...register("date", {
                                    required: "Required",
                                  })}
                                  className="form-control"
                                />
                              </div>
                            </div>
                            {!CandidateClosed && (
                              <div className="col-xxl-4 col-lg-4 col-md-4">
                                <div className="mb-3">
                                  <label className="form-label">Time </label>
                                  <input
                                    type="time"
                                    {...register("time")}
                                    className="form-control"
                                  />
                                </div>
                              </div>
                            )}
                            <div className="col-xxl-4 col-lg-4 col-md-4">
                              <div className="mb-3">
                                <label className="form-label">Time Zone
                                  <span className="text-danger">
                                      * {errors?.timezone_id?.message}
                                    </span>
                                </label>
                                <select
                                  {...register("timezone_id")}
                                  className="form-select"
                                >
                                  <option value="">Select Time Zone</option>
                                  {data?.timezones?.map((item) => (
                                    <option value={item.id} key={item.id}>
                                      {`${item.timezone} (${item.utc})`}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            {CandidateClosed && (
                              <div className="col-xxl-4 col-lg-4 col-md-4">
                                <div className="mb-3">
                                  <label className="form-label">
                                    Candidate Type
                                    <span className="text-danger">
                                      * {errors?.candidate_type?.message}
                                    </span>
                                  </label>
                                  <select
                                    {...register("candidate_type", {
                                      required: "Required",
                                    })}
                                    className="form-select"
                                  >
                                    <option value={""}>Select </option>
                                    <option value="Not Applicable">
                                      Not Applicable
                                    </option>
                                    <option value="Cross Border">
                                      Cross Border
                                    </option>
                                    <option value="Returning Natives">
                                      Returning Natives
                                    </option>
                                  </select>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                        {Evaluation && (
                          <div className="row">
                            <div className="col-xxl-6 col-lg-6 col-md-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  {minor_status == 30
                                    ? "Meeting With"
                                    : "Evaluation by"}{" "}
                                  <span className="text-danger">
                                    * {errors?.action_by_id?.message}
                                  </span>
                                </label>
                                <select
                                  {...register("action_by_id", {
                                    required: "Required",
                                  })}
                                  className="form-select"
                                >
                                  <option value="">Please Select</option>
                                  {data?.users?.map((item) => (
                                    <option value={item.id} key={item.id}>
                                      {`${item.firstname} ${item.lastname}`}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-xxl-6 col-lg-6 col-md-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Other Members
                                </label>
                                <Controller
                                  name="action_by_id_others"
                                  control={control}
                                  render={({ field }) => (
                                    <Select
                                      isMulti
                                      options={memberOptions}
                                      placeholder="Select Members"
                                      value={memberOptions.filter((option) =>
                                        (field.value || []).includes(
                                          option.value,
                                        ),
                                      )}
                                      onChange={(selected) =>
                                        field.onChange(
                                          selected?.map((x) => x.value) || [],
                                        )
                                      }
                                    />
                                  )}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                        {MeetingWith && (
                          <div className="row">
                            <div className={`mb-3 col-sm-6`}>
                              <label className="form-label">
                                Meeting With{" "}
                                <span className="fs-12">
                                  <i className="text-primary">
                                    Not In List -{" "}
                                    <a
                                      onClick={() =>
                                        setNewInterviewerModel(true)
                                      }
                                      className="btn btn-sm btn-primary fs-10"
                                    >
                                      Add New
                                    </a>
                                  </i>
                                  <span className="text-danger">
                                    {errors.clientName?.message}
                                  </span>
                                </span>
                              </label>
                              <Controller
                                name="clientName"
                                control={control}
                                rules={{
                                  required: "Required",
                                }}
                                render={({ field }) => (
                                  <Select
                                    isMulti
                                    options={interviewerOptions}
                                    placeholder="Select Interviewers"
                                    value={interviewerOptions.filter((option) =>
                                      (field.value || []).includes(
                                        option.value,
                                      ),
                                    )}
                                    onChange={(selected) =>
                                      field.onChange(
                                        selected?.map((x) => x.value) || [],
                                      )
                                    }
                                  />
                                )}
                              />
                            </div>
                            {meetingPlace && data?.interview?.length > 0 && (
                              <div className="col-sm-6">
                                <label className="form-label mb-3">
                                  Meeting Place{" "}
                                  <span className="text-danger">
                                    {errors.clientPlace?.message}
                                  </span>
                                </label>
                                <input
                                  {...register("clientPlace", {
                                    required: "Required",
                                  })}
                                  type="text"
                                  className="form-control"
                                />
                              </div>
                            )}
                          </div>
                        )}
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="mb-3">
                              <label className="form-label">
                                Add Notes{" "}
                                {![28, 29, 30].includes(minor_status) && (
                                  <span className="text-danger">
                                    * {errors.comments?.message}
                                  </span>
                                )}
                              </label>
                              <textarea
                                {...register("comments", {
                                  required: ![28, 29, 30].includes(minor_status)
                                    ? "Required"
                                    : false,
                                })}
                                className="form-control"
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <div className="d-flex align-items-center justify-content-end">
                  <button
                    type="button"
                    className="btn btn-outline-light border me-2"
                    data-bs-dismiss="modal"
                    onClick={onClose}
                    aria-label="Close"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditStatus;
